import { render, staticRenderFns } from "./franchise-glossary-definitions.vue?vue&type=template&id=b6b15d48&"
import script from "./franchise-glossary-definitions.vue?vue&type=script&lang=js&"
export * from "./franchise-glossary-definitions.vue?vue&type=script&lang=js&"
import style0 from "./franchise-glossary-definitions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports